import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'

import { DropdownButton, MenuItem } from 'react-bootstrap'
import { ListItem } from '~/views'

import style from './style.css'

export default class MessageRouteItem extends React.Component {
  
  static REMOVE_EVENT = 'removeMessageRoute';

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const { item : messageRoute, hideNavButtons } = this.props;
    return (
      <ListItem
        className={style.messageRouteItem} 
        onEvent={this.props.onEvent}
        item={messageRoute}
        selected={this.props.selected}
        title={messageRoute.name}
        subtitle={moment( messageRoute.lastModified ).fromNow()}
        leftView={this.renderLeft( messageRoute )}
        rightView={this.renderRight( messageRoute, hideNavButtons )} />
    )
  }

  renderLeft() {
    return null;
  }

  onDelete = () => {
    this.onEvent( MessageRouteItem.REMOVE_EVENT )
  }

  renderRight( messageRoute, hideNavButtons ) {
    return (
      <div>
        <DropdownButton pullRight bsStyle="link" title={<i className="fa fa-gear fa-lg fa-fw" />} key={messageRoute.id} id={`options-${messageRoute.id}`}>
          <MenuItem bsStyle="link"
            bsSize="large"
            className={style.pause} 
            onClick={this.onDelete}> 
            <i className="fa fa-times-circle fa-fw" />
            {' '}
            Remove
          </MenuItem>
        </DropdownButton>

      </div>
    )
  }

}
